import React from 'react'

import { Button } from '@paypalcorp/pp-react'
import { FEEDBACK_EVENT_NAME } from './constants'
import styles from './styles.module.css'

/**
 * Feedback component holds the Feedback button rendered on all pages.
 */
export function Feedback() {
  const feedbackButtonText = 'Feedback'

  const loadSurvey = () => {
    if (window.latmconf?.trackSprigEvent) {
      window.latmconf.trackSprigEvent(FEEDBACK_EVENT_NAME)
    }
  }

  return (
    <Button size="sm" className={styles.feedbackButton} onClick={loadSurvey}>
      {feedbackButtonText}
    </Button>
  )
}
